// extracted by mini-css-extract-plugin
module.exports = {"packageWrapper":"shoppingWrapper_packageWrapper__UR6JD","heading":"shoppingWrapper_heading__ZhdTf"};